import type { FormEvent } from 'react';
import { Card } from '@shared/ui/Card';
import { Button } from '@shared/ui/Button';
import { Input, Label, Field } from '@shared/ui/Input';
import { ContextSelect, Err, FileHint, Row, SubmitWrap } from '../styles';

export function CreateCheckCard({
  objectName,
  setObjectName,
  contractId,
  setContractId,
  projectId,
  setProjectId,
  period,
  setPeriod,
  ks2Files,
  setKs2Files,
  invoiceFiles,
  setInvoiceFiles,
  contextContracts,
  contextProjects,
  creating,
  can_write,
  error,
  onSubmit,
}: {
  objectName: string;
  setObjectName: (v: string) => void;
  contractId: string;
  setContractId: (v: string) => void;
  projectId: string;
  setProjectId: (v: string) => void;
  period: string;
  setPeriod: (v: string) => void;
  ks2Files: File[];
  setKs2Files: (v: File[]) => void;
  invoiceFiles: File[];
  setInvoiceFiles: (v: File[]) => void;
  contextContracts: Array<{ id: string; contract_number?: string | null; subject?: string | null; counterparty?: string | null }>;
  contextProjects: Array<{ id: string; code?: string | null; name: string }>;
  creating: boolean;
  can_write: boolean;
  error: string | null;
  onSubmit: (e: FormEvent) => void;
}) {
  return (
    <Card>
      <form onSubmit={onSubmit}>
        <Field>
          <Label>Объект</Label>
          <Input
            placeholder="Например: Завод ГБЖ, корпус КЖ"
            value={objectName}
            onChange={(e) => setObjectName(e.target.value)}
          />
        </Field>
        <Field>
          <Label>Привязка к договору Статута и проекту ПТО (необязательно)</Label>
          <Row $wrap>
            <ContextSelect
              value={contractId}
              onChange={(e) => setContractId(e.target.value)}
            >
              <option value="">— договор Статута —</option>
              {contextContracts.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.contract_number ? `№ ${c.contract_number}` : 'договор б/н'} ·{' '}
                  {(c.subject || c.counterparty || '').slice(0, 40)}
                </option>
              ))}
            </ContextSelect>
            <ContextSelect
              value={projectId}
              onChange={(e) => {
                const id = e.target.value;
                setProjectId(id);
                const found = contextProjects.find((p) => p.id === id);
                if (found?.name && !objectName.trim()) {
                  setObjectName(found.name);
                }
              }}
            >
              <option value="">— проект ПТО / объект —</option>
              {contextProjects.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.code ? `${p.code} · ` : ''}
                  {p.name}
                </option>
              ))}
            </ContextSelect>
          </Row>
        </Field>
        <Field>
          <Label>Отчётный период</Label>
          <Input
            placeholder="Например: Июнь 2026"
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
          />
        </Field>
        <Field>
          <Label>Акты КС-2 (источник объёмов)</Label>
          <Input
            type="file"
            multiple
            accept=".xlsx,.xlsm"
            onChange={(e) => setKs2Files(Array.from(e.target.files ?? []))}
          />
          <FileHint>Excel-выгрузка Гранд-Сметы. Выбрано файлов: {ks2Files.length}</FileHint>
        </Field>
        <Field>
          <Label>Накладные / первичка списания</Label>
          <Input
            type="file"
            multiple
            accept=".xlsx,.xlsm,.pdf,.docx"
            onChange={(e) => setInvoiceFiles(Array.from(e.target.files ?? []))}
          />
          <FileHint>
            ТОРГ-12 / УПД / М-11 / материальный отчёт (Excel или PDF). Выбрано файлов:{' '}
            {invoiceFiles.length}
          </FileHint>
        </Field>
        {error && <Err>{error}</Err>}
        <SubmitWrap>
          <Button
            type="submit"
            $variant="primary"
            disabled={creating || !can_write}
            title={!can_write ? 'Только чтение' : undefined}
          >
            {creating ? 'Запуск…' : 'Рассчитать М-29'}
          </Button>
        </SubmitWrap>
      </form>
    </Card>
  );
}
